<template>
	<div id="aml-cll-container" class="screen">
		<div class="screen-container">
			<NavAmlCll
				v-bind:si="patients[which].si"
			/>
			<main>
				<router-view/>
			</main>
		</div>
	</div>
</template>

<script>
import NavAmlCll from '@/components/NavAmlCll'

export default {
	components: {
		NavAmlCll
	},
	data() {
		return {
			which: this.$route.params.which,
			patients: {
				bishop: {
					si: 'cll',
				},
				carson: {
					si: 'aml',
				},
				gordon: {
					si: 'cll',
				},
				pierce: {
					si: 'aml'
				},
				neutropenia: {
					si: 'aml'
				},
				calendars: {
					si: 'cll'
				}
			}
		}
	}
}
</script>
<style scoped>
#aml-cll-container {
	background: url(../assets/aml-cll/background.png) no-repeat;
	background-size: cover;
}

main {
	display: flex;
	flex-direction: column;
	/* position: relative; */
}
</style>